const headingFont = ['"Space Grotesk"', '"Inter"', '"Helvetica Neue"', "sans-serif"].join(",");
const bodyFont = ['"Inter"', '"Helvetica Neue"', "sans-serif"].join(",");

// eslint-disable-next-line
export default {
    fontFamily: bodyFont,
    h1: {
        fontFamily: headingFont,
        fontWeight: 700,
        fontSize: 64,
        letterSpacing: "-0.02em",
    },
    h2: {
        fontFamily: headingFont,
        fontWeight: 700,
        fontSize: 52,
        letterSpacing: "-0.02em",
    },
    h3: {
        fontFamily: headingFont,
        fontWeight: 600,
        fontSize: 42,
        letterSpacing: "-0.01em",
    },
    h4: {
        fontFamily: headingFont,
        fontWeight: 600,
        fontSize: 32,
        letterSpacing: "-0.01em",
    },
    h5: {
        fontFamily: headingFont,
        fontWeight: 600,
        fontSize: 24,
    },
    h6: {
        fontFamily: headingFont,
        fontWeight: 500,
        fontSize: 20,
    },
    overline: {
        fontWeight: 500,
    },
    body1: {
        fontWeight: 400,
        fontSize: 17,
        lineHeight: 1.75,
    },
    body2: {
        fontWeight: 300,
        fontSize: 16,
        lineHeight: 1.7,
    },
};
